// extracted by mini-css-extract-plugin
export default {"content":"ProductionConfig_content__aOCV-","operationArea":"ProductionConfig_operationArea__6sewJ","required":"ProductionConfig_required__G9hSS"};